import { atom } from "recoil";
import {
  User,
  Columns,
  Filters,
  TableParams,
  Sorting,
} from "../components/types/user";
import { getDefaultCheckedItems } from "../commons/productItems";
import { VIEW_ID_ALL_FACTORY } from "../commons/views";
//アプリケーションバージョン-これを変更してからデプロイすること
export const appVersion = "1.8.0";

const defaultFilterParams: Filters = {
  salesNo: "", // 空文字列で初期化
  productNo: "", // 空文字列で初期化
  factory: [50], // 空の配列で初期化
  office: [0],
  situation: [0], // 空の配列で初期化
  field: [0],
  productItem: getDefaultCheckedItems(VIEW_ID_ALL_FACTORY),
};
const defaultTableParams: TableParams = {
  selectedPage: 1,
  junmpPage: "1",
  selectedDisplayNumber: 20,
  keywords: "",
  sorting: Array<Sorting>(),
  columnFilters: [],
};

const loginUser: User = {
  appVersion: appVersion,
  workerId: 0, // 社員番号は未使用なので0としますが、必要に応じてnullや適切なデフォルト値に変更してください。
  mail: "", // 空文字で初期化
  photoURL: "", // 空文字で初期化
  workerName: "", // 社員名を空文字で初期化
  viewId: 0, // ビューを選択する
  mode: "dark",
  isAuth: false, // 認証状態をfalseで初期化
  columnsAllFactory: Array<Columns>(), // カラム情報を空配列で初期化
  columnsPT: Array<Columns>(), // カラム情報を空配列で初期化
  columnsPV: Array<Columns>(), // カラム情報を空配列で初期化
  columnsKanto: Array<Columns>(), // カラム情報を空配列で初期化
  columnsFukuokaKumamoto: Array<Columns>(), // カラム情報を空配列で初期化
  columnsSite: Array<Columns>(),
  filters: defaultFilterParams, // フィルタ情報を空配列で初期化
  tableParams: defaultTableParams,
};

const initializeUserFromLocalStrate = () => {
  const storedUser = localStorage.getItem("LoginUserOnProcessVISION");
  if (storedUser) {
    try {
      const userObject = JSON.parse(storedUser);
      if (!userObject.appVersion || userObject.appVersion !== appVersion) {
        localStorage.clear();
        return loginUser;
      }
      return userObject;
    } catch (error) {
      console.error("Parsing error", error);
      return loginUser; // パースに失敗した場合のデフォルト値
    }
  } else {
    return loginUser; // LocalStorageにデータがない場合のデフォルト値
  }
};
export const userState = atom({
  key: "userState",
  default: initializeUserFromLocalStrate(),
});
